<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchDegradingPotentialForTax(typologyId) {
    return axios.get(`tipologias/${typologyId}/degrading_potentials_for_tax`, AS.getDefaultHeaders());
  },
  createDegradingPotentialForTax(typologyId, degradingPotential) {
    return axios.post(`tipologias/${typologyId}/degrading_potentials_for_tax`, { degrading_potential: degradingPotential }, AS.getDefaultHeaders());
  },
  updateDegradingPotentialForTax(typologyId, degradingPotential) {
    return axios.patch(`tipologias/${typologyId}/degrading_potentials_for_tax/${degradingPotential.id}`, { degrading_potential: degradingPotential }, AS.getDefaultHeaders());
  },
};
</script>
